import { _ as _assocIndexOf } from "./auth-service-tools1292.js";
var assocIndexOf = _assocIndexOf;

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}

var _listCacheGet = listCacheGet;
export { _listCacheGet as _ };